// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__3V-Kr","info":"Home_info__3jm_I"};